<template>
  <footer class="mobile_footer">
    <div class="mobile_footer__inner">
      <!-- Logo -->
      <router-link to="/home" class="mobile_footer__logoLink" aria-label="AiLife Home">
        <el-image :src="logoUrl" fit="contain" class="mobile_footer__logo" alt="AiLife Diagnostics">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </router-link>

      <!-- Contact Us -->
      <section class="mobile_footer__contact">
        <div class="mobile_footer__sectionTitle">Contact Us</div>

        <div class="mobile_footer__info">
          <div class="mobile_footer__infoRow">
            <i class="el-icon-location-outline"></i>
            <div>1920 Country Pl Pkwy, Suite 100, Pearland, TX 77584</div>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-phone-outline"></i>
            <a href="tel:+13463421802">(346) 342-1802</a>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-message"></i>
            <a href="mailto:contact@ailifeus.com">contact@ailifeus.com</a>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-time"></i>
            <div>
              <div class="mobile_footer__label">Client Services</div>
              <div class="mobile_footer__text">
                8:30 am—5:30 pm CDT, Monday—Friday
              </div>
            </div>
          </div>

          <div class="mobile_footer__infoRow">
            <i class="el-icon-time"></i>
            <div>
              <div class="mobile_footer__label">Sample Receiving</div>
              <div class="mobile_footer__text">
                8:30 am—5:30 pm CDT, Monday—Saturday
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Link Sections -->
      <el-collapse v-model="activeName" accordion class="mobile_footer__collapse">
        <el-collapse-item title="Test Menu" name="test">
          <ul class="mobile_footer__list">
            <li>
              <router-link to="/test/WholeGenomeSequencingProbandOnly">
                Whole Genome Sequencing
              </router-link>
            </li>
            <li>
              <router-link to="/test/WholeExomeSequencingProbandOnly">
                Whole Exome Sequencing
              </router-link>
            </li>
            <li>
              <router-link to="/test/category/audiology">
                Clinical Specialties
              </router-link>
            </li>
          </ul>
        </el-collapse-item>

        <el-collapse-item title="About Us" name="about">
          <ul class="mobile_footer__list">
            <li>
              <router-link to="/about/mission">
                Our Mission
              </router-link>
            </li>
            <li>
              <router-link to="/about/licenses">
                Our Licenses
              </router-link>
            </li>
            <li>
              <router-link to="/join">
                Careers
              </router-link>
            </li>
            <li>
              <router-link to="/about/privacy">
                Privacy Policy
              </router-link>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>

      <!-- Copyright -->
      <div class="mobile_footer__bottom">
        © {{ currentYear }} AiLife Diagnostics. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "mobile_footer",

  data() {
    return {
      activeName: "test",
      currentYear: new Date().getFullYear(),
      logoUrl: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo2.png",
    };
  },
};
</script>

<style lang="scss" scoped>
.mobile_footer {
  width: 100%;
  background: #2b63b6;
  color: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;

  .mobile_footer__inner {
    width: 100%;
    padding: 34px 18px 18px;
    box-sizing: border-box;
  }

  .mobile_footer__logoLink {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    text-decoration: none;
  }

  .mobile_footer__logo {
    width: 190px;
    height: 76px;
    display: block;
  }

  .mobile_footer__contact {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 18px;
    padding: 18px 16px;
    margin-bottom: 18px;
    box-sizing: border-box;
    box-shadow: 0 10px 24px rgba(10, 35, 78, 0.12);
  }

  .mobile_footer__sectionTitle {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.98);
    margin-bottom: 14px;
  }

  .mobile_footer__info {
    display: grid;
    gap: 12px;
  }

  .mobile_footer__infoRow {
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: 10px;
    align-items: start;
    font-size: 13px;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.86);

    i {
      margin-top: 3px;
      color: rgba(255, 255, 255, 0.92);
      font-size: 16px;
    }

    a {
      color: rgba(255, 255, 255, 0.92);
      text-decoration: none;
      word-break: break-word;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  .mobile_footer__label {
    font-size: 12px;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.94);
    margin-bottom: 2px;
  }

  .mobile_footer__text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.82);
  }

  .mobile_footer__collapse {
    border: none;
    margin-top: 6px;
  }

  .mobile_footer__list {
    list-style: none;
    padding: 8px 0 4px;
    margin: 0;

    li {
      margin: 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);

      &:last-child {
        border-bottom: none;
      }
    }

    a {
      display: block;
      padding: 12px 4px;
      color: rgba(255, 255, 255, 0.84);
      text-decoration: none;
      font-size: 14px;
      line-height: 1.45;
    }

    a:hover {
      color: #ffffff;
      text-decoration: underline;
    }
  }

  .mobile_footer__bottom {
    margin-top: 22px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.13);
    text-align: center;
    font-size: 12px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.68);
  }
}

/* Element UI Collapse 样式 */
.mobile_footer {
  ::v-deep .el-collapse {
    background: transparent;
  }

  ::v-deep .el-collapse-item {
    margin-bottom: 10px;
  }

  ::v-deep .el-collapse-item__header {
    height: 52px;
    line-height: 52px;
    padding: 0 16px;
    border: none;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.96);
    font-size: 15px;
    font-weight: 800;
    box-sizing: border-box;
  }

  ::v-deep .el-collapse-item__arrow {
    color: rgba(255, 255, 255, 0.86);
    font-weight: 700;
  }

  ::v-deep .el-collapse-item__wrap {
    border: none;
    background: transparent;
  }

  ::v-deep .el-collapse-item__content {
    padding: 0 16px 8px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 0 0 15px 15px;
  }
}

@media screen and (max-width: 375px) {
  .mobile_footer {
    .mobile_footer__inner {
      padding: 30px 14px 16px;
    }

    .mobile_footer__logo {
      width: 172px;
      height: 68px;
    }

    .mobile_footer__contact {
      padding: 16px 14px;
    }

    .mobile_footer__infoRow {
      font-size: 12.5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/footer/footer.vue